import api from "./helper/client";
import { API_ROUTES } from "./helper/routes";

export const addHoliday = async (tenantId: number, zoneId: number, holiday_date: string, name: string) => {
    const data = {
        tenant_id: tenantId,
        zone_id: zoneId,
        holiday_date: holiday_date,
        name: name
    };
    console.log("holiday body: ", data);

    const response = await api.post(API_ROUTES.HOLIDAY, data);
    return response;
}

export const getAllHolidays = async (tenantId: number) => {
    const response = await api.get(`${API_ROUTES.HOLIDAY}/list/${tenantId}`);
    return response.data.data;
}

export const editHoliday = async (tenantId: number, zoneId: number, holidayDate: string, name: string, holidayId: number) => {
    const data = {
        tenant_id: tenantId,
        zone_id: zoneId,
        holiday_date: holidayDate,
        name: name
    };
    console.log("edit holiday body: ", data);
    const response = await api.put(`${API_ROUTES.HOLIDAY}/${holidayId}`, data);

    return response.data.data;
}

export const deleteHoliday = async (holidayId: number) => {
    const response = await api.delete(`${API_ROUTES.HOLIDAY}/${holidayId}`);
    return response.data.data;
}